var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticStyle:{"width":"100%","max-width":"100px"},attrs:{"color":_vm.getStatusColor(_vm.status.name),"text-color":"white","label":""}},[_vm._v(" "+_vm._s(_vm.status.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }